// Unpublished Work © 2022 Deere & Company

import {RESET_DBS_CUSTOMER_PROFILE, SET_DBS_CUSTOMER_PROFILE_DATA} from '../../action-list';
import {DbsLabels} from '../../state/struct/dbs-customer-profile/dbs-labels';

const setDbsLabelsData = (state, action) => new DbsLabels(action.dbsCustomerProfile.dbsLabels);

const resetDbsLabelsData = () => new DbsLabels({});

export function dbsLabels(state = new DbsLabels({}), action = {}) {
    const actionHandlers = {
        [RESET_DBS_CUSTOMER_PROFILE]: resetDbsLabelsData,
        [SET_DBS_CUSTOMER_PROFILE_DATA]: setDbsLabelsData
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
